export const API_BASE_URL = import.meta.env.VITE_API_BASE_URL || 'http://localhost:7071/api';

export const API_ENDPOINTS = {
  getUserProfile: `${API_BASE_URL}/get-user-profile`,
  generateQR: `${API_BASE_URL}/generate-qr`,
  businessEntity: (shortCode: string) => `${API_BASE_URL}/business-entities/${shortCode}`,
  
  // Card Management endpoints (v2.0 - user ID extracted from Bearer token)
  listCards: `${API_BASE_URL}/cards`,
  getCard: (cardId: number) => `${API_BASE_URL}/cards/${cardId}`,
  createCard: `${API_BASE_URL}/cards`,
  updateCard: (cardId: number) => `${API_BASE_URL}/cards/${cardId}`,
  deleteCard: (cardId: number) => `${API_BASE_URL}/cards/${cardId}`,
  setDefaultCard: (cardId: number) => `${API_BASE_URL}/cards/${cardId}/set-default`,
  deactivateCard: (cardId: number) => `${API_BASE_URL}/cards/${cardId}/deactivate`,

  // Feedback
  submitFeedback: `${API_BASE_URL}/feedback`,
};

export const APP_CONFIG = {
  appName: 'Digital Business Card QR Generator',
  defaultColors: {
    primary: '#1E3A8A',
    secondary: '#FFFFFF',
  },
};
